import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cms-category",
  "use": "icon-cms-category-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cms-category\"><path d=\"M164.3 206.4c-29.8 0-54 24.2-54 54s24.2 54 54 54 54-24.2 54-54-24.2-54-54-54zM353.2 300.4h525c20.7 0 37.5-17.9 37.5-40s-16.8-40-37.5-40h-525c-20.7 0-37.5 17.9-37.5 40s16.8 40 37.5 40zM164.3 459.2c-29.8 0-54 24.2-54 54s24.2 54 54 54 54-24.2 54-54-24.2-54-54-54zM878.2 473.2h-525c-20.7 0-37.5 17.9-37.5 40s16.8 40 37.5 40h525c20.7 0 37.5-17.9 37.5-40s-16.8-40-37.5-40zM164.3 712c-29.8 0-54 24.2-54 54s24.2 54 54 54 54-24.2 54-54-24.2-54-54-54zM878.2 726h-525c-20.7 0-37.5 17.9-37.5 40s16.8 40 37.5 40h525c20.7 0 37.5-17.9 37.5-40s-16.8-40-37.5-40z\" fill=\"\" p-id=\"5268\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cms-category.svg
// module id = 6Ai6
// module chunks = 59